import {Component, Input, OnInit} from '@angular/core';
import {NavItem} from "@biletix/core/view-models/nav-item.model";

@Component({
  selector: 'btx-side-nav-list',
  templateUrl: './side-nav-list.component.html',
  styleUrls: ['./side-nav-list.component.scss'],
  standalone: false
})
export class SideNavListComponent implements OnInit {

  @Input() navItems!: NavItem[];

  @Input() depth: number = 0;

  constructor() {
  }

  ngOnInit(): void {
  }

}
